import React from 'react';
import { isNil } from 'lodash';

import { Button, Dataflow02Icon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import TRANSFORMATION_DRAWERS from 'app/pipeline-details/PipelineTransformationsSection/PipelineTransformationsDrawer/TRANSFORMATION_DRAWERS';
import { useDrawerContext } from 'app/shared/contexts/drawer';

const DISABLED_MESSAGE = 'No event split configured. Currently only configurable through the CLI.';

export default function PipelineEventSplitButton() {
  const { pipeline } = usePipelinePageContext();
  const { launchDrawer } = useDrawerContext();
  const deployedEventSplit = pipeline.deployedPipeline?.eventSplit;

  const onClick = () => {
    launchDrawer({
      drawer: TRANSFORMATION_DRAWERS.PIPELINE_EVENT_SPLIT,
      eventSplit: deployedEventSplit,
    });
  };

  const disabled = isNil(deployedEventSplit);

  return (
    <WithTooltip show={disabled} title={DISABLED_MESSAGE}>
      <Button
        variant="outlined"
        size="medium"
        color="secondary"
        startIcon={<Dataflow02Icon />}
        onClick={onClick}
        disabled={disabled}
      >
        Pipeline Event Split
      </Button>
    </WithTooltip>
  );
}
